import { items } from "@api/stores/purchaseInvoices/returns/items/path";
import { reclaim } from "@api/stores/purchaseInvoices/returns/reclaim/path";
import { apiPathFunc } from "@api/util/apiPathFunc";

import type { IExtractParams } from "@routes";

const pathBase = `/stores/:storeId/purchase-invoices/:purchaseInvoiceId/returns/`;
const pathById = `${pathBase}:returnsId/`;

export type IPathBaseParam = IExtractParams<typeof pathBase>;
export type IPathByIdParam = IExtractParams<typeof pathById>;

export const returns = {
  get: apiPathFunc(pathById),
  getAll: apiPathFunc(pathBase),
  post: apiPathFunc(pathBase),
  reclaim,
  items,
};
